const VideoLink = function (props) {
    console.log(props.data)
    return (
        <div className="audioLink">
            <h2>{props.data.Title}</h2>
            <div>{props.data.MODComments}</div>
                <iframe width="100%" height="315" src={props.data.ModLinksLink.NavigateUrl} frameborder="0" allowfullscreen="allowFullScreen" 
                allow="autoplay; encrypted-media"></iframe>
            <br/>
        </div>
    );
}
export default VideoLink;
